// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.controlButton {
  color: white;
  font-size: 12px;
  /* smaller font-size for iPhone display */
  font-weight: bold;
  width: 1.5em;
  height: 16em;
}
.link {
  margin-right: 25px;
}
.volumn-slider {
  width: 50px;
  height: 1px;
}
.volumn-slider::-webkit-slider-thumb {
  background-color: #7e3030;
}
.volumn-slider::-webkit-slider-runnable-track {
  height: 3px;
}
/* Default order for mobile views */
.order-row-1 {
  order: 2;
  margin-top: 5px;
  margin-bottom: 5px;
}
.order-row-2 {
  order: 3;
}
.order-row-3 {
  order: 1;
  margin-top: 20px;
  margin-bottom: 20px;
}
.order-row-4 {
  order: 4;
}
.order-row-5 {
  order: 5;
}
.player-container {
  min-height: 600px;
}
/* Change order for larger screens */
@media (min-width: 767px) {
  .volumn-slider {
    width: 100px;
    height: 2px;
  }
  .volumn-slider::-webkit-slider-thumb {
    background-color: #7e3030;
  }
  .volumn-slider::-webkit-slider-runnable-track {
    height: 5px;
  }
  .player-container {
    min-height: 600px;
  }
  .order-row-1 {
    order: 1;
  }
  .order-row-2 {
    order: 2;
    height: 700px;
    object-fit: contain;
  }
  .order-row-3 {
    order: 3;
    position: relative;
    bottom: 0;
    left: 52%;
    transform: translateX(-50%);
    margin-top: 5px;
    margin-bottom: 5px;
    height: 20px;
  }
  .order-row-4 {
    order: 4;
    position: fixed;
    margin-top: 5px;
    margin-bottom: 5px;
    top: 75%;
    left: 51%;
    transform: translateX(-50%);
  }
  .order-row-5 {
    order: 5;
  }
}
/*# sourceMappingURL=radioStyle.css.map */`, "",{"version":3,"sources":["webpack://./radioStyle.css","webpack://./client/Components/radioStyle.css"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,eAAA;ECCA,yCAAyC;EDAzC,iBAAA;EACA,YAAA;EACA,YAAA;ACEF;ADCA;EACE,kBAAA;ACCF;ADEA;EACE,WAAA;EACA,WAAA;ACAF;ADEA;EACE,yBAAA;ACAF;ADEA;EACE,WAAA;ACAF;AACA,mCAAmC;ADGnC;EACE,QAAA;EACA,eAAA;EACA,kBAAA;ACDF;ADGA;EACE,QAAA;ACDF;ADGA;EACE,QAAA;EACA,gBAAA;EACA,mBAAA;ACDF;ADGA;EACE,QAAA;ACDF;ADGA;EACE,QAAA;ACDF;ADIA;EACE,iBAAA;ACFF;AACA,oCAAoC;ADKpC;EACE;IACE,YAAA;IACA,WAAA;ECHF;EDKA;IACE,yBAAA;ECHF;EDKA;IACE,WAAA;ECHF;EDKA;IACE,iBAAA;ECHF;EDMA;IACE,QAAA;ECJF;EDMA;IACE,QAAA;IACA,aAAA;IACA,mBAAA;ECJF;EDMA;IACE,QAAA;IACA,kBAAA;IACA,SAAA;IACA,SAAA;IACA,2BAAA;IACA,eAAA;IACA,kBAAA;IACA,YAAA;ECJF;EDMA;IACE,QAAA;IACA,eAAA;IACA,eAAA;IACA,kBAAA;IACA,QAAA;IACA,SAAA;IACA,2BAAA;ECJF;EDMA;IACE,QAAA;ECJF;AACF;AACA,yCAAyC","sourcesContent":[".controlButton {\n  color: white;\n  font-size: 12px; /* smaller font-size for iPhone display */\n  font-weight: bold;\n  width: 1.5em;\n  height: 16em;\n}\n\n.link {\n  margin-right: 25px;\n}\n\n.volumn-slider {\n  width: 50px;\n  height: 1px;\n}\n.volumn-slider::-webkit-slider-thumb {\n  background-color: rgb(126, 48, 48);\n}\n.volumn-slider::-webkit-slider-runnable-track {\n  height: 3px;\n}\n\n/* Default order for mobile views */\n.order-row-1 {\n  order: 2;\n  margin-top: 5px;\n  margin-bottom: 5px;\n}\n.order-row-2 {\n  order: 3;\n}\n.order-row-3 {\n  order: 1;\n  margin-top: 20px;\n  margin-bottom: 20px;\n}\n.order-row-4 {\n  order: 4;\n}\n.order-row-5 {\n  order: 5;\n}\n\n.player-container {\n  min-height: 600px;\n}\n\n/* Change order for larger screens */\n@media (min-width: 767px) {\n  .volumn-slider {\n    width: 100px;\n    height: 2px;\n  }\n  .volumn-slider::-webkit-slider-thumb {\n    background-color: rgb(126, 48, 48);\n  }\n  .volumn-slider::-webkit-slider-runnable-track {\n    height: 5px;\n  }\n  .player-container {\n    min-height: 600px;\n  }\n\n  .order-row-1 {\n    order: 1;\n  }\n  .order-row-2 {\n    order: 2;\n    height:700px;\n    object-fit: contain;\n  }\n  .order-row-3 {\n    order: 3;\n    position: relative;\n    bottom: 0;\n    left: 52%;\n    transform: translateX(-50%);\n    margin-top: 5px;\n    margin-bottom: 5px;\n    height: 20px;\n  }\n  .order-row-4 {\n    order: 4;\n    position: fixed;\n    margin-top: 5px;\n    margin-bottom: 5px;\n    top: 75%;\n    left: 51%;\n    transform: translateX(-50%);\n  }\n  .order-row-5 {\n    order: 5;\n  }\n}\n",".controlButton {\n  color: white;\n  font-size: 12px;\n  /* smaller font-size for iPhone display */\n  font-weight: bold;\n  width: 1.5em;\n  height: 16em;\n}\n.link {\n  margin-right: 25px;\n}\n.volumn-slider {\n  width: 50px;\n  height: 1px;\n}\n.volumn-slider::-webkit-slider-thumb {\n  background-color: #7e3030;\n}\n.volumn-slider::-webkit-slider-runnable-track {\n  height: 3px;\n}\n/* Default order for mobile views */\n.order-row-1 {\n  order: 2;\n  margin-top: 5px;\n  margin-bottom: 5px;\n}\n.order-row-2 {\n  order: 3;\n}\n.order-row-3 {\n  order: 1;\n  margin-top: 20px;\n  margin-bottom: 20px;\n}\n.order-row-4 {\n  order: 4;\n}\n.order-row-5 {\n  order: 5;\n}\n.player-container {\n  min-height: 600px;\n}\n/* Change order for larger screens */\n@media (min-width: 767px) {\n  .volumn-slider {\n    width: 100px;\n    height: 2px;\n  }\n  .volumn-slider::-webkit-slider-thumb {\n    background-color: #7e3030;\n  }\n  .volumn-slider::-webkit-slider-runnable-track {\n    height: 5px;\n  }\n  .player-container {\n    min-height: 600px;\n  }\n  .order-row-1 {\n    order: 1;\n  }\n  .order-row-2 {\n    order: 2;\n    height: 700px;\n    object-fit: contain;\n  }\n  .order-row-3 {\n    order: 3;\n    position: relative;\n    bottom: 0;\n    left: 52%;\n    transform: translateX(-50%);\n    margin-top: 5px;\n    margin-bottom: 5px;\n    height: 20px;\n  }\n  .order-row-4 {\n    order: 4;\n    position: fixed;\n    margin-top: 5px;\n    margin-bottom: 5px;\n    top: 75%;\n    left: 51%;\n    transform: translateX(-50%);\n  }\n  .order-row-5 {\n    order: 5;\n  }\n}\n/*# sourceMappingURL=radioStyle.css.map */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
